import types from './types';

const getInitialData = () => ({
  type: types.GET_ACCESS_REQUEST_INITIAL_DATA
});

const newAccessRequest = accessRequestDto => ({
  type: types.NEW_ACCESS_REQUEST,
  params: { accessRequestDto }
});

export default {
  getInitialData,
  newAccessRequest
};
